/** End-of-period run-rate projection: used ÷ daysElapsed × daysTotal. */
export const projectPeriodUsage = (
  used: number,
  daysElapsed: number,
  daysTotal: number
): number => {
  if (daysElapsed <= 0 || daysTotal <= 0) {
    return used;
  }
  return (used / daysElapsed) * daysTotal;
};

/** GraphQL Time scalars are typed as Date but arrive as ISO strings from loaders. */
export const toDate = (value: Date | string | null | undefined): Date | null => {
  if (value == null) {
    return null;
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** End is exclusive; display the last inclusive calendar day in UTC. */
export const inclusivePeriodEnd = (end: Date): Date => {
  const lastDay = new Date(end);
  lastDay.setUTCDate(lastDay.getUTCDate() - 1);
  return lastDay;
};

const yearInTimezone = (date: Date, timezone: string): string =>
  new Intl.DateTimeFormat('en-US', { year: 'numeric', timeZone: timezone }).format(date);

/** Format [start, end) for display; end is exclusive. Includes years when the range spans two. */
export const formatUsagePeriodRange = (
  startValue: Date | string | null | undefined,
  endExclusiveValue: Date | string | null | undefined,
  timezone = 'UTC'
): string | null => {
  const start = toDate(startValue);
  const end = toDate(endExclusiveValue);
  if (!start || !end) {
    return null;
  }

  const inclusiveEnd = inclusivePeriodEnd(end);
  const sameYear = yearInTimezone(start, timezone) === yearInTimezone(inclusiveEnd, timezone);
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
    timeZone: timezone
  });

  return `${formatter.format(start)} – ${formatter.format(inclusiveEnd)}`;
};
